import React from 'react'
import { Fragment } from 'react'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import Footer from '../../component/Other/Footer'

const Privacy = () => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Privacy Policy"} to={"Privacy Policy"} />
                </div>

                <section>
                    <div className="container">
                        <div className="text-center mb-4">
                            <h2 className='normal font__size--50 text__50-1024 text__50-sm'>Privacy Policy</h2>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-8">

                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>At Bloom & Grow, we are committed to protecting the privacy and security of our customers. This privacy policy describes how we collect, use, and share your personal information when you use our website bloom&grow.com.</p>

                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Information We Collect</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>When you use our website, we may collect certain information about you, such as your name, email address, phone number, billing and shipping address, and payment information. We may also collect information about your use of our website, such as your IP address, browser type, and operating system.</p>

                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>How We Use Your Information</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-2'>We may use your personal information to:</p>

                                <ul className='normal font__size--20 text__20-1024 color__gray-1 mb-2'>
                                    <li>Fulfill orders and process payments</li>
                                    <li>Communicate with you about your orders and account1</li>
                                    <li>Respond to your inquiries and customer service requests</li>
                                    <li>Improve our website and services</li>
                                    <li>Send you promotional emails and newsletters (you can opt-out at any time)</li>
                                </ul>

                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>We will not sell, rent, or share your personal information with third parties for their marketing purposes without your consent.</p>


                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Data Security</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>We take reasonable measures to protect your personal information from loss, theft, and unauthorized access, disclosure, alteration, and destruction. However, please be aware that no method of transmission over the internet or electronic storage is 100% secure.</p>
                               
                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Cookies</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>We may use cookies and similar tracking technologies to enhance your experience on our website and collect information about your browsing behavior. You can control the use of cookies through your browser settings.</p>
                             
                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Third-Party Links</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>Our website may contain links to third-party websites that are not operated by us. We are not responsible for the privacy practices of these websites and recommend that you review their privacy policies.</p>

                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Updates to Privacy Policy</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>We may update this privacy policy from time to time to reflect changes in our practices or applicable laws. We encourage you to review this policy periodically.</p>

                                <h5 className='semi-bold font__size--20 text__20-1024 mb-2'>Contact Us</h5>
                                <p className='normal font__size--20 text__20-1024 color__gray-1 mb-3'>If you have any questions or concerns about this privacy policy or our privacy practices, please contact us at [Contact Information].</p>

                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </Fragment>
    )
}

export default Privacy